'use strict';
import {
  modal
} from './modal.js';

async function loadData() {

  const response = await fetch('./js/data/pets.json')
  let names = await response.json()
  let key;
  let list = document.querySelector('.card__grid');
  // get json objects from file

  let numOfPages = 8; // change items on every pagination page
  // let xe = window.matchMedia("(max-width: 767.98px)");
  if (window.matchMedia('(max-device-width: 768.98px)').matches) {
    numOfPages = 6;
  }
  if (window.matchMedia('(max-device-width: 500.98px)').matches) {
    numOfPages = 3;
  }
  let countOfPages = Math.ceil(names.length / numOfPages);
  /** the number of pages is
      always equal to the lenght of the array **/
let getPagiBtn = []
  for (let i = 1; i <= countOfPages; i++) {
    let pagBtn = document.createElement('button');
    pagBtn.classList.add('btns', 'btns__number');
    pagBtn.innerHTML = i;
    let getBtnLeft = document.querySelector('.btns__right');
    getBtnLeft.insertAdjacentElement('beforeBegin', pagBtn);
    getPagiBtn.push(pagBtn);
  }
  showPages(getPagiBtn[0]);

  // let getPagiBtn = document.querySelectorAll('.btns__number');
  for (let pagiBtn of getPagiBtn) {

    pagiBtn.addEventListener('click', function () {
      showPages(this);
    })
  }

  function showPages(pagiBtn){
    let pageNum = +pagiBtn.innerHTML;
    let start = (pageNum - 1) * numOfPages;
    let end = start + numOfPages;


    let notes = names.slice(start, end);
    list.innerHTML = '';


    for (key of notes) {
      list.innerHTML += `
        <li class="card__body">
        <div class="card__image"><img class="card-img" src="${key.img}" alt="${key.description}"></div>
                <p class="card__name">${key.name} </p>

                <button class="btn btn--learnmore card__btn" id="learnmore" data-modal-button="${key.data}">Learn more</button>
                </li>

                <div id="${key.data}" data-modal class="modal__wrapper hidden">
                <div class="modal__body">
                <img data-modal-close class="modal__close--btn" src="./img/modal_close_button.png" alt="close btn">
                  <div class="modal__image">
                    <img src="${key.img}" alt="Pet photo" class="modal-img">
                  </div>
                  <div class="modal__text" data-modal>
                    <p class="modal__name">${key.name}</p>
                    <p class="modal__dogtype"><span class="modal__type">${key.type}</span> - <span class="modal__breed">${key.breed}</span></p>
                    <p class="modal__desqr">${key.description}</p>
                      <div class="modal__about">
                      <p class="modal__about--item">Age:<span class="modal__about--more">&thinsp;${key.age}</span></p>
                      <p class="modal__about--item">Inoculations:<span class="modal__about--more">&thinsp;${key.inoculations}</span></p>
                      <p class="modal__about--item">Diseases:<span class="modal__about--more">&thinsp;${key.diseases}</span></p>
                      <p class="modal__about--item">Age:<span class="modal__about--more">&thinsp;${key.parasites}</span></p>
                      </div>
                  </div>
                </div>
              </div>
                `

    }

    modal()
  }
}
loadData()
